module.exports = __webpack_public_path__ + "static/media/loft.4a9f246e.jpeg";